import useInterval from "helpers/hooks/useInterval";
import { SnackbarKey, useSnackbar } from "notistack";
import { backend } from "Backend";
import { useState } from "react";
import { Config } from "Config";

const ServerConnectivity = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [snackbarKey, setSnackbarKey] = useState<SnackbarKey>();
  useInterval(async () => {
    try {
      await backend.healthCheck();
      if (snackbarKey) {
        closeSnackbar(snackbarKey);
      }
    } catch (e) {
      if (!snackbarKey) {
        const snackbarKey = enqueueSnackbar(
          "Internet connection disrupted. Please check connection before making any changes.",
          {
            variant: "server",
            persist: true,
            preventDuplicate: true,
            onClose: () => setSnackbarKey(undefined),
          }
        );
        setSnackbarKey(snackbarKey);
      }
    }
  }, Config.serverConnectionInterval);

  return <></>;
};

export default ServerConnectivity;
